var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CCol',{staticClass:"mb-4",attrs:{"xl":"2","md":"4","sm":"6","xs":"12"}},[_c('div',{class:['theme-color w-75 rounded mb-3', _vm.color],style:({ paddingTop: '75%' })}),_vm._t("default"),_c('ColorView')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }